var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSelectIco = function SvgSelectIco(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.383,
    cy: 14,
    r: 13,
    stroke: "#868686"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.097 18.676a.944.944 0 0 1-1.428 0l-5.294-6.113A.944.944 0 0 1 9.089 11h10.588c.809 0 1.243.951.714 1.563l-5.294 6.113Z",
    fill: "#868686"
  })));
};

export default SvgSelectIco;